import customSqlSource from 'data/sources/common/customSqlSource';
import { CUSTOMSQL_LAYER_ID } from 'components/layers/common/CustomSqlLayer';

import customSqlSecondarySource from 'data/sources/common/customSqlSecondary';
import { CUSTOMSQL_SECONDARY_LAYER_ID } from 'components/layers/common/CustomSqlSecondaryLayer';

import customSqlThirdSource from 'data/sources/common/customSqlThird';
import { CUSTOMSQL_THIRD_LAYER_ID } from 'components/layers/common/CustomSqlThirdLayer';

import customSqlFourthSource from 'data/sources/common/customSqlFourth';
import { CUSTOMSQL_FOURTH_LAYER_ID } from 'components/layers/common/CustomSqlForthLayer';

import customSqlFifthSource from 'data/sources/common/customSqlFifth';
import { CUSTOMSQL_FIFTH_LAYER_ID } from 'components/layers/common/CustomSqlFifthLayer';

import browardZoningDistrictSource from 'data/sources/bmpo/browardZoningDistrictSource';
import { BROWARDZONINGDISTRICT_LAYER_ID } from 'components/layers/bmpo/BrowardZoningDistrictLayer';

import browardPremoProjectSource from 'data/sources/bmpo/browardPremoProjectSource';
import { BROWARDPREMOPROJECT_LAYER_ID } from 'components/layers/bmpo/BmpoPremoProjectLayer';

import { BROWARDPARCEL_LAYER_ID } from 'components/layers/bmpo/BrowardParcelLayer';
import browardParcelSource from 'data/sources/bmpo/browardParcelSource';

import { BROWARDBUSSTOP_LAYER_ID } from 'components/layers/bmpo/BrowardBusStopLayer';
import browardBusStopSource from 'data/sources/bmpo/browardBusStopSource';

import { BROWARDTRAINSTOP_LAYER_ID } from 'components/layers/bmpo/BrowardTrainStopLayer';
import browardTrainStopSource from 'data/sources/bmpo/browardTrainStopSource';

import { BROWARDBUSROUTE_LAYER_ID } from 'components/layers/bmpo/BrowardBusRouteLayer';
import browardBusRouteSource from 'data/sources/bmpo/browardBusRouteSource';

import { BROWARDTRAINROUTE_LAYER_ID } from 'components/layers/bmpo/BrowardTrainRouteLayer';
import browardTrainRouteSource from 'data/sources/bmpo/browardTrainRouteSource';

import { BROWARDTRANSITFACILITY_LAYER_ID } from 'components/layers/bmpo/BrowardTransitFacilityLayer';
import browardTransitFacilitiesSource from 'data/sources/bmpo/browardTransitFacilitiesSource';

import { BROWARDCITYLINE_LAYER_ID } from 'components/layers/bmpo/BrowardCityLineLayer';
import browardCityLineSource from 'data/sources/bmpo/browardCityLineSource';

import { BROWARDFUTURELANDUSE_LAYER_ID } from 'components/layers/bmpo/BrowardFutureLandUseLayer';
import browardFutureLandUseSource from 'data/sources/bmpo/browardFutureLandUseSource';

import { BROWARDHFABOND_LAYER_ID } from 'components/layers/bmpo/BrowardHFABondLayer';
import browardHFABondSource from 'data/sources/bmpo/browardHFABondSource';

import { MIRAMARDEVELOPMENTPROJECT_LAYER_ID } from 'components/layers/bmpo/MiramarDevelopmentProjectLayer';
import miramarDevelopmentProjectSource from 'data/sources/bmpo/miramarDevelopmentProjectSource';

import { MIRAMARPRAPOSEDTOC_LAYER_ID } from 'components/layers/bmpo/MiramarPraposedTOCLayer';
import miramarPraposedTOCSource from 'data/sources/bmpo/miramarPraposedTOCSource';

import { MIRAMARPRAPOSEDMITAC_LAYER_ID } from 'components/layers/bmpo/MiramarPraposedMITACLayer';
import miramarPraposedMITACSource from 'data/sources/bmpo/miramarPraposedMITACSource';

import { CURRENTFLOODZONES_LAYER_ID } from 'components/layers/infrastructure/CurrentFloodZonesLayer';
import currentFloodZonesSource from 'data/sources/infrastructure/currentFloodZonesSource';

import { SLR2_3FEET_LAYER_ID } from 'components/layers/infrastructure/SLR2_3FeetLayer';
import slr2_3FeetSource from 'data/sources/infrastructure/slr2_3FeetSource';

import { SLR3_4FEET_LAYER_ID } from 'components/layers/infrastructure/SLR3_4FeetLayer';
import slr3_4FeetSource from 'data/sources/infrastructure/slr3_4FeetSource';

import { SLR5_4FEET_LAYER_ID } from 'components/layers/infrastructure/SLR5_4FeetLayer';
import slr5_4FeetSource from 'data/sources/infrastructure/slr5_4FeetSource';

import { MIRAMARWATERSTORAGE_LAYER_ID } from 'components/layers/infrastructure/MiramarWaterStorageLayer';
import miramarWaterStorageSource from 'data/sources/infrastructure/miramarWaterStorageSource';

import { MIRAMARWATERLINES_LAYER_ID } from 'components/layers/infrastructure/MiramarWaterLinesLayer';
import miramarWaterLinesSource from 'data/sources/infrastructure/miramarWaterLinesSource';

import { MIRAMARLIFTSTATIONS_LAYER_ID } from 'components/layers/infrastructure/MiramarLiftStationsLayer';
import miramarLiftStationsSource from 'data/sources/infrastructure/miramarLiftStationsSource';

import { MIRAMARGRAVITYSEWER_LAYER_ID } from 'components/layers/infrastructure/MiramarGravitySewerLayer';
import miramarGravitySewerSource from 'data/sources/infrastructure/miramarGravitySewerSource';

import { MIRAMARSTORMDRAINLINES_LAYER_ID } from 'components/layers/infrastructure/MiramarStormDrainLinesLayer';
import miramarStormDrainLinesSource from 'data/sources/infrastructure/miramarStormDrainLinesSource';

import { LANDSURFACETEMPERATURE_LAYER_ID } from 'components/layers/environment/LandSurfaceTemperatureLayer';
import landSurfaceTemperatureSource from 'data/sources/environment/landSurfaceTemperatureSource';

import { POPULATION_LAYER_ID } from 'components/layers/demographics/PopulationLayer';
import populationSource from 'data/sources/demographics/populationSource';

import { INCOME_LAYER_ID } from 'components/layers/demographics/IncomeLayer';
import incomeSource from 'data/sources/demographics/incomeSource';

import { HIGH_RISK_NETWORK_LAYER_ID } from 'components/layers/safety/highRiskNetworkLayer';
import highRiskNetworkSource from 'data/sources/safety/highRiskNetworkSource';

import { HIGH_INJURY_NETWORK_LAYER_ID } from 'components/layers/safety/highInjuryNetworkLayer';
import highInjuryNetworkSource from 'data/sources/safety/highInjuryNetworkSource';

import { HISTORICAL_ALL_CRASH_LAYER_ID } from 'components/layers/safety/historicalAllCrashLayer';
import { HISTORICAL_BICYCLIST_CRASH_LAYER_ID } from 'components/layers/safety/histroicalBicyclistCrashLayer';
import { HISTORICAL_PEDESTRIAN_CRASH_LAYER_ID } from 'components/layers/safety/hstoricalPedestrianCrashLayer';
import { KSI_CRASH_LAYER_ID } from 'components/layers/safety/ksiCrashLayer';
import { KSI_BICYCLIST_CRASH_LAYER_ID } from 'components/layers/safety/ksiBicyclistCrashLayer';
import { KSI_PEDESTRIAN_CRASH_LAYER_ID } from 'components/layers/safety/ksiPedestrianCrashLayer';
import historicalCrashSource from 'data/sources/safety/historicalCrashSource';

import { SCHOOL_LAYER_ID } from 'components/layers/safety/schoolLayer';
import schoolSource from 'data/sources/safety/schoolSource';

import {PARK_LAYER_ID} from 'components/layers/safety/parkLayer';
import parkSource from 'data/sources/safety/parkSource';

import wazeAlertsSource from 'data/sources/waze/wazeAlertsSource';
import { WAZEALERTS_LAYER_ID } from 'components/layers/waze/WazeAlertsLayer';

import { JOBACCESS30MINTRANSITDIFF_LAYER_ID } from 'components/layers/urbansim/JobAccess30MinTransitDiffLayer';
import jobAccess30minuteTransitDiff_ResidentialPriceDiff_DensityHouseholdsAcreDiff_HouseholdPopulationDensityAcresDiffSource from 'data/sources/urbansim/jobAccess30minuteTransitDiff_ResidentialPriceDiff_DensityHouseholdsAcreDiff_HouseholdPopulationDensityAcresDiffSource';
import { DENSITYHOUSEHOLDSACREDIFF_LAYER_ID } from 'components/layers/urbansim/DensityHouseHoldsAcreDiffLayer';
import { HOUSEHOLDPOPULATIONDENSITYACRESDIFF_LAYER_ID } from 'components/layers/urbansim/HouseholdPopulationDensityAcresDiffLayer';
import { HOUSEHOLDPOPULATIONDENSITYACERS_LAYER_ID } from 'components/layers/urbansim/HouseholdPopulationDensityAcresLayer';
import householdPopulationDensityAcresSource from 'data/sources/urbansim/householdPopulationDensityAcresSource';
import browardMTPResilienceRoadNetworkSource from 'data/sources/urbansim/browardMTPResilienceRoadNetworkSource';
import { BROWARDMTPRESILIENCEROADNETWORK_LAYER_ID } from 'components/layers/urbansim/BrowardMTPResilienceRoadNetworkLayer';
import { HOUSEHOLDSINNOAAFLOODHIGH2070DIFF_LAYER_ID } from 'components/layers/urbansim/HouseholdsInNoaaFloodHigh2070DiffLayer';
import householdsInNoaaFloodHigh2070Diff_SumTotalJobsDiff_JobAccess45MinuteTransitDiffSource from 'data/sources/urbansim/householdsInNoaaFloodHigh2070Diff_SumTotalJobsDiff_JobAccess45MinuteTransitDiffSource';
import { SUMTOTALJOBSDIFF_LAYER_ID } from 'components/layers/urbansim/SumTotalJobsDiffLayer';
import { JOBACCESS45MINUTETRANSIT_LAYER_ID } from 'components/layers/urbansim/JobAccess45MinuteTransitLayer';
import { RESIDENTIALPRICEDIFF_LAYER_ID } from 'components/layers/urbansim/ResidentialPriceDiffLayer';
import jobAccess30minuteTransitDiff_HouseholdPopulationDensityAcresDiff_DensityHouseholdsAcreDiffSource from 'data/sources/bmpoInvestmentAnalysis/jobAccess30minuteTransitDiff_HouseholdPopulationDensityAcresDiff_DensityHouseholdsAcreDiffSource';
import { JOBACCESS30MINUTETRANSITDIFF_LAYER_ID } from 'components/layers/bmpoInvestmentAnalysis/JobAccess30minuteTransitDiffLayerInvAny';
import { HOUSEHOLDPOPULATIONDENSITYACRESDIFFINVANY_LAYER_ID } from 'components/layers/bmpoInvestmentAnalysis/HouseholdPopulationDensityAcresDiff';
import { DENSITYHOUSEHOLDSACREDIFFINVANY_LAYER_ID } from 'components/layers/bmpoInvestmentAnalysis/DensityHouseholdsAcreDiffInvAnyLayer';
import { RESIDENTIALPRICEDIFFINVANY_LAYER_ID } from 'components/layers/bmpoInvestmentAnalysis/ResidentialPriceDiffInvAnyLayer';
import { SUMTOTALJOBSDIFFINVANY_LAYER_ID } from 'components/layers/bmpoInvestmentAnalysis/SumTotalJobsDiffLayer';
import sumTotalJobsDiff_HouseholdsInNoaaFloodHigh2070Diff_JobAccess45MinuteTransitDiffSource from 'data/sources/bmpoInvestmentAnalysis/sumTotalJobsDiff_HouseholdsInNoaaFloodHigh2070Diff_JobAccess45MinuteTransitDiffSource';
import { HOUSEHOLDSINNOAAFLOODHIGH2070DIFFINVANY_LAYER_ID } from 'components/layers/bmpoInvestmentAnalysis/HouseholdsInNoaaFloodHigh2070DiffInvAnyLayer';
import { JOBACCESS45MINUTETRANSITDIFFINVANY_LAYER_ID } from 'components/layers/bmpoInvestmentAnalysis/JobAccess45MinuteTransitDiffInvAnyLayer';
import { RENTBURDENDIFF_LAYER_ID } from 'components/layers/urbansim/RentBurdenDiffLayer';
import rentBurdenDiffSource from 'data/sources/urbansim/rentBurdenDiffSource';
import { RENTBURDENDIFFINVANY_LAYER_ID } from 'components/layers/bmpoInvestmentAnalysis/RentBurdenDiffInvAnyLayer';
import rentBurdenDiffInvAnySource from 'data/sources/bmpoInvestmentAnalysis/rentBurdenDiffInvAnySource';

const layerSourceMapping = [
  {
    layer: CUSTOMSQL_LAYER_ID,
    source: customSqlSource.id,
    type: 'sql',
  },
  {
    layer: CUSTOMSQL_SECONDARY_LAYER_ID,
    source: customSqlSecondarySource.id,
    type: 'sql-secondary',
  },
  {
    layer: CUSTOMSQL_THIRD_LAYER_ID,
    source: customSqlThirdSource.id,
    type: 'sql-third',
  },
  {
    layer: CUSTOMSQL_FOURTH_LAYER_ID,
    source: customSqlFourthSource.id,
    type: 'sql-fourth',
  },
  {
    layer: CUSTOMSQL_FIFTH_LAYER_ID,
    source: customSqlFifthSource.id,
    type: 'sql-fifth',
  },
  {
    layer: BROWARDZONINGDISTRICT_LAYER_ID,
    source: browardZoningDistrictSource.id,
  },
  {
    layer: BROWARDBUSSTOP_LAYER_ID,
    source: browardBusStopSource.id,
  },
  {
    layer: BROWARDPREMOPROJECT_LAYER_ID,
    source: browardPremoProjectSource.id,
  },
  {
    layer: BROWARDTRAINSTOP_LAYER_ID,
    source: browardTrainStopSource.id,
  },
  {
    layer: BROWARDBUSROUTE_LAYER_ID,
    source: browardBusRouteSource.id,
  },
  {
    layer: BROWARDTRAINROUTE_LAYER_ID,
    source: browardTrainRouteSource.id,
  },
  {
    layer: BROWARDTRANSITFACILITY_LAYER_ID,
    source: browardTransitFacilitiesSource.id,
  },
  {
    layer: BROWARDCITYLINE_LAYER_ID,
    source: browardCityLineSource.id,
  },
  {
    layer: BROWARDFUTURELANDUSE_LAYER_ID,
    source: browardFutureLandUseSource.id,
  },
  {
    layer: BROWARDHFABOND_LAYER_ID,
    source: browardHFABondSource.id,
  },
  {
    layer: MIRAMARDEVELOPMENTPROJECT_LAYER_ID,
    source: miramarDevelopmentProjectSource.id,
  },
  {
    layer: MIRAMARPRAPOSEDTOC_LAYER_ID,
    source: miramarPraposedTOCSource.id,
  },
  {
    layer: MIRAMARPRAPOSEDMITAC_LAYER_ID,
    source: miramarPraposedMITACSource.id,
  },
  {
    layer: BROWARDPARCEL_LAYER_ID,
    source: browardParcelSource.id,
  },
  {
    layer: CURRENTFLOODZONES_LAYER_ID,
    source: currentFloodZonesSource.id,
  },
  {
    layer: SLR2_3FEET_LAYER_ID,
    source: slr2_3FeetSource.id,
  },
  {
    layer: SLR3_4FEET_LAYER_ID,
    source: slr3_4FeetSource.id,
  },
  {
    layer: SLR5_4FEET_LAYER_ID,
    source: slr5_4FeetSource.id,
  },
  {
    layer: MIRAMARWATERSTORAGE_LAYER_ID,
    source: miramarWaterStorageSource.id,
  },
  {
    layer: MIRAMARWATERLINES_LAYER_ID,
    source: miramarWaterLinesSource.id,
  },
  {
    layer: MIRAMARLIFTSTATIONS_LAYER_ID,
    source: miramarLiftStationsSource.id,
  },
  {
    layer: MIRAMARGRAVITYSEWER_LAYER_ID,
    source: miramarGravitySewerSource.id,
  },
  {
    layer: MIRAMARSTORMDRAINLINES_LAYER_ID,
    source: miramarStormDrainLinesSource.id,
  },
  {
    layer: LANDSURFACETEMPERATURE_LAYER_ID,
    source: landSurfaceTemperatureSource.id,
  },
  {
    layer: POPULATION_LAYER_ID,
    source: populationSource.id,
  },
  {
    layer: INCOME_LAYER_ID,
    source: incomeSource.id,
  },
  {
    layer: HIGH_RISK_NETWORK_LAYER_ID,
    source: highRiskNetworkSource.id,
  },
  {
    layer: HIGH_INJURY_NETWORK_LAYER_ID,
    source: highInjuryNetworkSource.id,
  },
  {
    layer: HISTORICAL_ALL_CRASH_LAYER_ID,
    source: historicalCrashSource.id, 
  },
  {
    layer: HISTORICAL_BICYCLIST_CRASH_LAYER_ID,
    source: historicalCrashSource.id,
  },
  {
    layer: HISTORICAL_PEDESTRIAN_CRASH_LAYER_ID,
    source: historicalCrashSource.id,
  },
  {
    layer: KSI_CRASH_LAYER_ID,
    source: historicalCrashSource.id,
  },
  {
    layer: KSI_BICYCLIST_CRASH_LAYER_ID,
    source: historicalCrashSource.id,
  },
  {
    layer: KSI_PEDESTRIAN_CRASH_LAYER_ID,
    source: historicalCrashSource.id,
  },
  {
    layer: SCHOOL_LAYER_ID,
    source: schoolSource.id,
  },
  {
    layer: PARK_LAYER_ID,
    source: parkSource.id,
  },
  {
    layer: JOBACCESS30MINTRANSITDIFF_LAYER_ID,
    source:
      jobAccess30minuteTransitDiff_ResidentialPriceDiff_DensityHouseholdsAcreDiff_HouseholdPopulationDensityAcresDiffSource.id,
  },
  {
    layer: DENSITYHOUSEHOLDSACREDIFF_LAYER_ID,
    source:
      jobAccess30minuteTransitDiff_ResidentialPriceDiff_DensityHouseholdsAcreDiff_HouseholdPopulationDensityAcresDiffSource.id,
  },
  {
    layer: HOUSEHOLDPOPULATIONDENSITYACRESDIFF_LAYER_ID,
    source:
      jobAccess30minuteTransitDiff_ResidentialPriceDiff_DensityHouseholdsAcreDiff_HouseholdPopulationDensityAcresDiffSource.id,
  },
  {
    layer: RESIDENTIALPRICEDIFF_LAYER_ID,
    source:
      jobAccess30minuteTransitDiff_ResidentialPriceDiff_DensityHouseholdsAcreDiff_HouseholdPopulationDensityAcresDiffSource.id,
  },
  {
    layer: HOUSEHOLDPOPULATIONDENSITYACERS_LAYER_ID,
    source: householdPopulationDensityAcresSource.id,
  },
  {
    layer: BROWARDMTPRESILIENCEROADNETWORK_LAYER_ID,
    source: browardMTPResilienceRoadNetworkSource.id,
  },
  {
    layer: HOUSEHOLDSINNOAAFLOODHIGH2070DIFF_LAYER_ID,
    source:
      householdsInNoaaFloodHigh2070Diff_SumTotalJobsDiff_JobAccess45MinuteTransitDiffSource.id,
  },
  {
    layer: SUMTOTALJOBSDIFF_LAYER_ID,
    source:
      householdsInNoaaFloodHigh2070Diff_SumTotalJobsDiff_JobAccess45MinuteTransitDiffSource.id,
  },
  {
    layer: JOBACCESS45MINUTETRANSIT_LAYER_ID,
    source:
      householdsInNoaaFloodHigh2070Diff_SumTotalJobsDiff_JobAccess45MinuteTransitDiffSource.id,
  },

  {
    layer: JOBACCESS30MINUTETRANSITDIFF_LAYER_ID,
    source:
      jobAccess30minuteTransitDiff_HouseholdPopulationDensityAcresDiff_DensityHouseholdsAcreDiffSource.id,
  },
  {
    layer: HOUSEHOLDPOPULATIONDENSITYACRESDIFFINVANY_LAYER_ID,
    source:
      jobAccess30minuteTransitDiff_HouseholdPopulationDensityAcresDiff_DensityHouseholdsAcreDiffSource.id,
  },
  {
    layer: DENSITYHOUSEHOLDSACREDIFFINVANY_LAYER_ID,
    source:
      jobAccess30minuteTransitDiff_HouseholdPopulationDensityAcresDiff_DensityHouseholdsAcreDiffSource.id,
  },
  {
    layer: RESIDENTIALPRICEDIFFINVANY_LAYER_ID,
    source:
      jobAccess30minuteTransitDiff_HouseholdPopulationDensityAcresDiff_DensityHouseholdsAcreDiffSource.id,
  },

  {
    layer: SUMTOTALJOBSDIFFINVANY_LAYER_ID,
    source:
      sumTotalJobsDiff_HouseholdsInNoaaFloodHigh2070Diff_JobAccess45MinuteTransitDiffSource.id,
  },
  {
    layer: HOUSEHOLDSINNOAAFLOODHIGH2070DIFFINVANY_LAYER_ID,
    source:
      sumTotalJobsDiff_HouseholdsInNoaaFloodHigh2070Diff_JobAccess45MinuteTransitDiffSource.id,
  },
  {
    layer: JOBACCESS45MINUTETRANSITDIFFINVANY_LAYER_ID,
    source:
      sumTotalJobsDiff_HouseholdsInNoaaFloodHigh2070Diff_JobAccess45MinuteTransitDiffSource.id,
  },
  {
    layer: RENTBURDENDIFF_LAYER_ID,
    source: rentBurdenDiffSource.id,
  },
  {
    layer: RENTBURDENDIFFINVANY_LAYER_ID,
    source: rentBurdenDiffInvAnySource.id,
  },
  {
    layer: WAZEALERTS_LAYER_ID,
    source: wazeAlertsSource.id,
  },
];

export const getLayerFromSource = (id) => {
  let ans = '';
  layerSourceMapping.forEach((map) => {
    if (map.source === id) {
      ans = map.layer;
    }
  });
  return ans;
};

export const getSourceFromLayer = (id) => {
  let ans = '';
  layerSourceMapping.forEach((map) => {
    if (map.layer === id) {
      ans = map.source;
    }
  });
  return ans;
};

export const getSqlTypes = () => {
  return ['sql', 'sql-secondary', 'sql-third', 'sql-fourth', 'sql-fifth'];
};

export const getLayerFromType = (id) => {
  let ans = '';
  layerSourceMapping.forEach((map) => {
    if (map?.type === id) {
      ans = map.layer;
    }
  });
  return ans;
};

export const getSourceFromType = (id) => {
  let ans = '';
  layerSourceMapping.forEach((map) => {
    if (map?.type === id) {
      ans = map.source;
    }
  });
  return ans;
};

export const getIdFromType = (type) => {
  if (type === 'sql') return 0;
  if (type === 'sql-secondary') return 1;
  if (type === 'sql-third') return 2;
  if (type === 'sql-fourth') return 3;
  if (type === 'sql-fifth') return 4;
  return -1;
};
